import { Button } from '@socialchorus/shared-ui-components';
import { MouseEventHandler, useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import useScreenTitle from '../../../common/use-screen-title';
import styles from './styles.module.scss';

interface Props {
  errorMessage: string;
}

export function BoxError() {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation<Props>();
  const isIosWebview = /advomobo/.test(navigator.userAgent);
  const isAndroidWebview = /SocialChorus|advodroid/.test(navigator.userAgent);
  const isMobileWebview = isIosWebview || isAndroidWebview;
  const errorMessage =
    (location?.state?.errorMessage as string) ??
    t('screens.box.error.not_found', { object: t('common.file') });

  useScreenTitle(t('screens.box.error.title'));

  const onClickCta: MouseEventHandler = useCallback(
    (e) => {
      e.preventDefault();
      history.goBack();
    },
    [history]
  );

  useEffect(() => {
    localStorage.removeItem('lastLocation'); // Make sure users won't be sent here again
  }, []);

  return (
    <div className={styles.NotFound__Container}>
      <div className={styles.NotFound}>
        <img src="/images/feed-empty.svg" alt="" />
        <h2>{errorMessage}</h2>
        {!isMobileWebview && (
          <Button
            className={styles.NotFound__Cta}
            variant="text"
            label={t('screens.box.error.cta')}
            onClick={onClickCta}
          />
        )}
      </div>
    </div>
  );
}
